import module from 'empresa/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const catalogoTipoFirma = [
  {id: '001', descripcion: 'Individual'},
  {id: '002', descripcion: 'Mancomunada'},
]

export default class EmpresaCuentasAgregarComponent {
  empresaId = null
  procesando = false
  guardar = false
  data = {
    id_cuenta: undefined,
    id_banco: undefined,
    numero_cuenta: '',
    clabe: '',
    id_moneda: undefined,
    numero_cotrato: '',
    cuenta_contable: '',
    cuenta_contable_complementaria: '',
    representante_legal: '',
    tipo_cuenta: undefined,
    firmante_1: undefined,
    firmante_1_tipo: undefined,
    firmante_2: undefined,
    firmante_2_tipo: undefined,
    firmante_3: undefined,
    firmante_3_tipo: undefined,
    firmante_4: undefined,
    firmante_4_tipo: undefined,
    contrato_bancario: '',
    id_sucursal: undefined,
  }
  catalogo = {
    tipoFirma: catalogoTipoFirma,
    banco: [],
    firmante: [],
    moneda: [],
    sucursal: [],
  }
  validacionesNumeroCuenta = {
    existe: (cuenta) => {
      return this.$q((resolve, reject) => {
        this.EmpresaCuentasExisteService.get(this.empresaId, cuenta)
          .then(({data}) => {
            if (data.existe) {
              reject()
            } else {
              resolve()
            }
          })
      })
    },
  }

  constructor ($filter, $q, $state, CatalogoBancos, CatalogoFirmantes, CatalogoMonedas, CatalogoSucursales, EmpresaCuentasExiste) {
    this.$filter = $filter
    this.$q = $q
    this.$state = $state
    this.CatalogoBancos = CatalogoBancos
    this.CatalogoFirmantes = CatalogoFirmantes
    this.CatalogoMonedas = CatalogoMonedas
    this.CatalogoSucursales = CatalogoSucursales
    this.EmpresaCuentasExisteService = EmpresaCuentasExiste
  }

  $onInit () {
    this.promise = this.$q.all([
      this.CatalogoBancos.get()
        .then(({data}) => (this.catalogo.banco = orderBy(data, ['descripcion']))),
      this.CatalogoFirmantes.get()
        .then(({data}) => (this.catalogo.firmante = orderBy(data, ['descripcion']))),
      this.CatalogoMonedas.get()
        .then(({data}) => (this.catalogo.moneda = orderBy(data, ['descripcion']))),
      this.CatalogoSucursales.get()
        .then(({data}) => (this.catalogo.sucursal = orderBy(data, ['descripcion']))),
    ])
  }

  confirmacion (data) {
    this.guardar = false

    if (data) {
      this.$state.go('finances.cuentasBancarias.detalle.editar.informacion', {
        idEmpresa: data.empresa_id,
        idCliente: data.id_cliente,
        idCuenta: data.id_cuenta,
      })
    }
  }
}

module.component('empresaCuentasAgregar', {
  controller: EmpresaCuentasAgregarComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuentas/agregar/component.js